module.exports = __webpack_public_path__ + "static/media/premiereFois_01_thumb_hover.0a6e969e.png";